import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from 'src/app/modules/core/services/user.service';
import { NullDataHandlerService } from 'src/app/modules/core/services/null-data-handler.service';
import { UserViewModel } from 'src/app/models/users/user-view.model';

@Injectable({
    providedIn: 'root'
})
export class UserDetailsResolverService extends NullDataHandlerService implements Resolve<UserViewModel> {

    constructor(private userService: UserService, public router: Router) {
        super(router);
    }

    resolve(route: ActivatedRouteSnapshot,
            state: RouterStateSnapshot): Observable<UserViewModel> | Promise<UserViewModel> | UserViewModel {
        let id = route.paramMap.get('id') || '';
        if (id == 'new') return new UserViewModel();

        return this.userService.getById(id).then((response) => {
            if (!response) 
                this.redirectToNotFound();
            else
                return response;
        });
    }
}
